import { HLMRA, RA, SALI, SYSTEMS, VALLADOLID } from '@constants/System';
import { System } from '@models/System';


export const getSystem = (systemId: number): System => {
	switch (systemId) {
		case SYSTEMS.SALI:
			return SALI;
		case SYSTEMS.HLMRA:
			return HLMRA;
		case SYSTEMS.RA:
			return RA;
		case SYSTEMS.VALLADOLID:
		default:
			return VALLADOLID;
	}
};
